/* =====================================================
   geoLocationService
   Wrapper reutilizable para el endpoint de geolocalización.

   Usage:
     geoLocationService.geolocate()                          // auto-detect IP del caller
     geoLocationService.geolocate('8.8.8.8')                // IP explícita
     geoLocationService.geolocateWithHeaders(getAuthHeaders())          // auto-detect + auth
     geoLocationService.geolocateWithHeaders(getAuthHeaders(), '8.8.8.8') // IP + auth
   ===================================================== */
angular.module('bizmetryApp').service('geoLocationService', [
  '$http', '$q', 'CONFIG',
  function ($http, $q, CONFIG) {

    const GEOLOCATION_URL = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/geolocation';

    // ── Método base interno ───────────────────────────────────────────────────
    // extraConfig acepta el mismo formato que getAuthHeaders() devuelve:
    // { headers: { Authorization: 'Bearer ...' } }
    function _doGeolocate(ip, extraConfig) {
      var config = angular.extend({}, extraConfig || {});

      if (ip) {
        config.params = angular.extend({}, config.params || {}, { ip: ip });
      }

      return $http.get(GEOLOCATION_URL, config)
        .then(function (response) {
          var geo = response.data;
          if (!geo) {
            console.warn('📍 [geoLocationService] Empty response');
            return null;
          }
          console.log('📍 [geoLocationService] Resolved:', geo.ip, '→', geo.city, ',', geo.country_name);
          return geo;
        })
        .catch(function (error) {
          console.warn('📍 [geoLocationService] Failed:', error.status, error.statusText);
          return null;
        });
    }

    // ── API pública ───────────────────────────────────────────────────────────

    // Sin auth explícita — el interceptor $http inyecta el Bearer automáticamente
    this.geolocate = function (ip) {
      return _doGeolocate(ip, null);
    };

    // Con config explícita — mismo formato que getAuthHeaders():
    // { headers: { Authorization: 'Bearer ...' } }
    this.geolocateWithHeaders = function (config, ip) {
      return _doGeolocate(ip, config);
    };

  }
]);